/**
 * Function that generates a unique ID taht might be used in a element id
 * @param {string} id any string. Eg: "subnav-wrapper"
 * @returns {string} a formatted unique string. Eg: "subnav-wrapper_8dkq6h38b"
 */
export function generateUniqueId(id: string = ''): string {
  return `${id}_${Math.random().toString(36).substr(2, 9)}`;
}
